import { SelectC } from 'components'
import { useState } from 'react'
import { useLoadOrdersCustomers } from 'modules/orders/hooks'
import { useDebounce } from 'utils'
import { useFormContext } from 'react-hook-form'

export const SelectDeliveryAddressCompany = () => {
  const [search, setSearch] = useState<string>('')
  const searchDebounced = useDebounce(search, 250)
  const { watch } = useFormContext()

  const customerId = watch('customer')?.id

  const { data, isLoading } = useLoadOrdersCustomers({
    page: 1,
    limit: 100,
    search: searchDebounced,
    filters: {},
    sellerId: watch('seller')?.id
  })

  const handleChange = (value: string, reason: string) => {
    if (reason === 'input' || reason === 'clear') setSearch(value)
  }

  const deliveryCustomers = data?.data.filter((item) => item.id !== customerId)

  return (
    <SelectC
      name="deliveryAddressCompany"
      label="Cliente Remessa"
      options={deliveryCustomers}
      onInputChange={(_, value, reason) => handleChange(value, reason)}
      getOptionLabel={(option: any) => option?.id + ' - ' + option?.name}
      loading={isLoading}
    />
  )
}
